module.exports = __webpack_public_path__ + "img/personalisee.66a4518a.png";